import { useState, useEffect } from 'react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_nj-liquor-delivery/artifacts/q14l1b4u_1001594216.jpg";

export default function AgeGate({ onResult }) {
  const handleYes = () => {
    localStorage.setItem('age_status', 'adult');
    onResult('adult');
  };

  const handleNo = () => {
    localStorage.setItem('age_status', 'minor');
    onResult('minor');
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-[#0B0E14]/90 backdrop-blur-xl" data-testid="age-gate-modal">
      <div className="bg-[#12151C] border border-white/10 rounded-2xl p-8 sm:p-12 max-w-md mx-4 text-center shadow-2xl animate-fade-in">
        <img src={LOGO_URL} alt="Hoboken LGD" className="w-20 h-20 rounded-xl object-cover mx-auto mb-6" />
        <h2 className="font-['Playfair_Display'] text-2xl sm:text-3xl font-medium text-white mb-3">Welcome!</h2>
        <p className="text-[#94A3B8] font-light mb-2">HOBOKEN LIQUOR GROCERY & DELI</p>
        <p className="text-white font-medium mb-8">Are you 21 years of age or older?</p>
        <div className="flex gap-4">
          <button onClick={handleYes} className="flex-1 bg-[#cc3737] hover:bg-[#d94444] text-white rounded-full py-3 font-medium transition-colors" data-testid="age-gate-verify-button">
            Yes, I'm 21+
          </button>
          <button onClick={handleNo} className="flex-1 border border-white/20 hover:border-white/40 text-white rounded-full py-3 font-medium transition-all" data-testid="age-gate-deny-button">
            No, I'm Under 21
          </button>
        </div>
        <p className="text-[#64748B] text-xs mt-6 font-light">If under 21, you'll still see our grocery, deli & hot food items. Alcohol products require age verification.</p>
      </div>
    </div>
  );
}
